// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/nesto-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    min-height: 100vh;
}

.sidebar {
    /* flex: 1; */
    min-height: 100vh;


    background: black;
    width: 100%;
    padding-top: 2rem;
    padding-bottom: 2rem;
    z-index: 100;
    /* box-shadow: 0px 10px 20px rgba(196, 200, 208, 0.4); */
}

.wid {
    width: 80px;
}

.top-side {
    display: flex;
    justify-content: center;
}

.inovent {
    color: white;
    font-size: 25px;
    font-style: bold;
}

.link-style {
    width: 96%;
    background-color: #373E43;
    height: 40px;
    display: flex;
    padding-left: 4%;
    align-items: center;
    margin-bottom: 1px;
    cursor: pointer;
}

.link-style-center {
    width: 96%;
    background-color: #56626A;
    height: 40px;
    display: flex;
    padding-left: 2%;
    align-items: center;
    justify-content: center;
    margin-bottom: 1px;
}

.link-style-center:hover {
    background-color: #373E43;
    cursor: pointer;
}

.link-text {
    color: white;
    padding-left: 2%;
    margin: 0;
}

.header {
    width: 100%;
    background-color: black;
    display: flex;
    flex-wrap: wrap;
}

.header-text {
    /* color: white; */
    padding-left: 2%;
    margin: 0px;
    font-size: 13px;
}

.line {
    width: 1px;
    height: 28px;
    background-color: white;
    margin-top: 5px;
    margin-bottom: 3px;
}

.ino-admin:hover {
    background-color: #373E43;
    cursor: pointer;
}

.dashboard-main {
    margin: 1%;

    border: 1px solid black;
    width: 99%;

    display: flex;
    flex-direction: column;

    border-radius: 15px;
}

.dashboard-main2 {
    margin: 1%;
    margin-right: 0;
    border: 1px solid black;
    width: 50%;

    display: flex;
    flex-direction: column;

    border-radius: 15px;
}

.dashboard-top {
    background: #D3D8DB;
    height: 75px;
    width: 100%;
    border-radius: 15px 15px 0 0;
    padding-top: 1%;
    padding-left: 2%;
    padding-right: 2%;
    display: flex;
    justify-content: space-between;
}

.dashboard-top2 {
    background: #D3D8DB;
    height: 75px;
    width: 100%;
    border-radius: 15px 15px 0 0;
    padding: 1%;
    display: flex;
    justify-content: space-between;
}

.refresh-btn {
    background-color: #C82333;
    border: none;
    border-radius: 5px;
    margin-top: 20%;
    width: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
}

.refresh-text {
    color: white;
    margin: 0;
}

.stock-count {
    font-size: 22px;
    margin-top: 0;
    font-weight: 500;
    color: #091114;
}

.dashboard-bottom {
    padding: 1%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.filter-text {
    color: white;
    font-weight: 500;
}

.drop-input {
    width: 200px;
    border: 1px solid white;
   
    height: 34px;
    border-radius: 10px;
    background: transparent;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
}

.drop-input-black {
    width: 200px;
    border: 1px solid rgb(0, 0, 0);
   
    height: 34px;
    border-radius: 10px;
    color: black !important;
    background: rgb(240, 240, 240);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
}

.drop-input-black::placeholder {
    color: black !important;
}

.store {
    color: white;
    margin: 0;
    margin-left: 5%;
}

.dropdown-list {
    width: 180px;
    height: 400px;
    background-color: #373E43;
    overflow: scroll;
    scroll-behavior: smooth;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1%;
    position: absolute;
}

.drop-data {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.show {
    /* color: white; */
    margin: 0 10px 0;
    font-weight: 500;
}

.run-btn {
    background-color: #0069D9;
    border: none;
    border-radius: 10px;
    padding: 10px;
    min-width: 160px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
}

.run-text {
    color: white;
    font-size: 15px;
    margin: 0;
}

.box-1 {
    width: 33%;
    height: 160px;
    background-color: #091114;
    border-radius: 10px;
    padding: 2%;
}

.admin-main {
    margin: 3%;
    border: 1px solid black;
    width: 95%;

    display: flex;
    flex-direction: column;

    border-radius: 15px;
}

.admin-bottom {
    padding: 1%;
    display: flex;

    justify-content: space-between;
}

.box-2 {
    width: 66%;

    background-color: #091114;
    border-radius: 10px;
    padding: 2%;
}

.box-3 {
    width: 33%;

    background-color: #091114;
    border-radius: 10px;
    padding: 2%;
}

.total-score {
    color: white;
    font-size: 18px;
    font-weight: 500;
    margin: 0;
}

.circle {
    border: 2px solid white;
    width: 30px;
    border-radius: 50%;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;


}

.plus {
    color: white;
    font-size: 25px;
    width: 30px;
    /* height: 45px; */
    margin: 0;
    font-weight: 500;
}

.number {
    font-size: 100px;
    color: white;
    font-weight: bold;
    margin: 5%;
    margin-left: 30%;
    margin-top: -7%
}

.long-data {
    color: white;
    font-size: 13px;
}

.last {
    color: white;
    font-size: 18px;
    font-weight: 500;
}

.select-store-btn {
    width: 180px;
    height: 40px;
    background: transparent;
    border: 1px solid white;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.select-store-text {
    color: white;
    margin: 0;
}

.matching {
    color: white;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 0;
}

.zero {
    font-size: 18px;
    color: white;
    font-weight: 500;
}

.red-line {
    width: 100%;
    height: 5px;
    background-color: #C82333;
}

.small-text {
    font-size: 12px;
    color: white;
    margin: 0;
    font-weight: 500;
}

.small-text-zero {
    font-size: 12px;
    color: white;
    text-align: center;
    margin: 0;
    font-weight: 500;
}

.white-box-1 {
    width: 335px;
    height: 420px;
    background-color: white;

}

.white-box-2 {
    width: 335px;
    height: 390px;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

}

.white-box-3 {
    width: 335px;
    height: 390px;
    background-color: white;

}

.total-score-tag {
    font-size: 15px;
    font-weight: 500;
    color: black;
    margin: 0;
}

.detail-btn {
    width: 80px;
    height: 35px;
    background-color: rgb(90, 98, 104);
    border: none;
    border-radius: 5px;
}

.detail-text-tag {
    margin: 0;
    color: white;

}

.tag-input {
    width: 185px;
    height: 30px;
    border: 1px solid grey;
    color: #000;
}

.tag-input::placeholder {
    color: gray;
}

.tag-input[type=text] {
    color: #000
}

.img-preview {
    margin: 0;
    font-weight: 500;
}

.epc-input {
    width: 97%;
    height: 30px;
    border: 1px solid grey;
}

.picker-input {
    width: 200px;
    border: 1px solid gray;
    height: 34px;
    border-radius: 5px;
    background: transparent;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
}

/* .picker-list {
    width: 180px;
    height: 400px;
    background-color: transparent;
    overflow: scroll;
    scroll-behavior: smooth;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1%;
} */

.picker-list {
    /* width: 100%; */
    height: 237px;
    position: absolute;
    /* background-color: #333232; */
    background: black;
    scroll-behavior: smooth;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: scroll;
    /* padding: 1%; */
    overflow-x: hidden;
}

.print-btn {
    background-color: #0069D9;
    border: none;
    border-radius: 10px;

    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
}
.print-btn:disabled{
    cursor: not-allowed; 
}

.print-text {
    color: white;
    font-size: 17px;
    margin: 0;
}

.users-bottom {
    padding: 2%;
    display: flex;
    width: 100%;
    justify-content: space-between;

}

.users-bottom2 {
    padding: 2%;
    display: flex;
    width: 100%;
    justify-content: space-between;

}

.role-bottom {
    padding: 2%;
    display: flex;
    width: 90%;
    /* justify-content: space-between; */
}

.add-user-btn {
    background-color: #C82333;
    border: none;
    border-radius: 5px;
    margin-left: 2%;
    width: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
}

.back-user-btn {
    background-color: #C82333;
    border: none;
    border-radius: 5px;

    width: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    margin-top: 3%;
    margin-left: 5%;
    margin-bottom: -3%;
}

.add-text {
    color: white;
    margin: 0;
    font-size: 13px;
}

.transfer-bottom {
    padding: 2%;
    display: flex;
    width: 100%;
    justify-content: space-between;

}

.forminput {
    width: 270px;
    height: 35px;
    background: transparent;
    border: 1px solid white;
    border-radius: 5px;
}

.forminput:focus {
    background: white;
    border: 1px solid white;
    outline: none;
}

.forminput::placeholder {
    padding-left: 10px;
}

.ibt-text {
    font-size: 15px;
    color: white;
}

.drop-input-form {
    width: 270px;
    border: 1px solid white;
    height: 34px;
    border-radius: 5px;
    padding-left: 15px;
    background: transparent;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
}

.recharts-cartesian-grid-horizontal line {
    stroke-opacity: 0;
}


/* .dropdown-list-form {
    width: 280px;
    height: 400px;
    background-color: transparent;
    overflow: scroll;
    scroll-behavior: smooth;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 1%;
} */

.dropdown-list-form {
    width: 100%;
    height: 237px;
    position: absolute;
    /* background-color: #333232; */
    background: black;
    scroll-behavior: smooth;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: scroll;
    padding: 1%;
    overflow-x: hidden;
}

.dropdown-para-wrapper:nth-child(even) {
    background: #212529;
}

.dropdown-para-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    cursor: pointer;
}

.dropdown-para-wrapper p {
    color: white;
    font-weight: 400;
    margin: 0;
    line-height: 30px;
    font-size: 12px;
}

.drop-input-form-2 {
    width: 100%;
    border: 1px solid white;
    height: 34px;
    border-radius: 5px;
    background: transparent;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
}

.dropdown-list-form-2 {
    width: 100%;
    height: 237px;
    position: absolute;
    background: black;
    scroll-behavior: smooth;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: scroll;
    padding: 1%;
    overflow-x: hidden;
}

.store-2 {
    color: white;
    margin: 0;
    margin-left: 2.1%;
}

.textarea-form {
    width: 100%;
    height: 150px;
    background: transparent;
    border: 1px solid white;
    border-radius: 5px;
}

.textarea-form:focus {
    background: white;
    border: 1px solid white;
    outline: none;
}

.textarea-form::placeholder {
    padding-left: 10px;
    padding-top: 8px;
}

.receiving-btn {
    background-color: #f8f9fa;
    color: #212529;
    border: none;
    border-radius: 5px;
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    margin-top: 6%;
}

.get-detail-btn {
    background-color: #f8f9fa;
    color: #000;
    width: 100px;
    height: 35px;
    border-radius: 5px;
}

.clear-btn {
    background-color: #C82333;
    border: none;
    border-radius: 5px;
    width: 75px;
    height: 35px;
    color: white;
}

.admin-menu-btn {
    width: 250px;
    height: 38px;
    margin-bottom: 2%;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.admin-menu-bottom {
    padding: 2%;
}

.admin-menu-txt {
    color: white;
    margin: 0;
}

[data-table-theme*=dark] {
    width: 100%;
    color: white;
    background: #1B1F22;
    font-size: 10pt;
    text-align: center;
    border-collapse: collapse;
}

[data-table-theme*=#373E43] thead th,
[data-table-theme*=dark] tfoot th {
    color: #aaa;
    background: rgba(0255, 255, 255, .15);
}



[data-table-theme*=dark] th,
[data-table-theme*=dark] td {
    padding: .5em;
    border: 1px solid grey;
    /* Prevent very long content from stretching the table */
    max-width: 300px;
    overflow-wrap: anywhere; /* allow breaking long words/strings */
    word-break: break-word;
}



.audit-bottom {
    padding: 2%;
    display: flex;
    width: 100%;
    justify-content: space-between;

}

.inventory-bottom {
    padding: 2%;
    display: flex;
    width: 100%;
    justify-content: space-between;


}

.store-bottom {
    padding: 2%;
    display: flex;

    justify-content: space-between;
}

.action-btn {
    width: 60px;
    height: 30px;
    background: transparent;
    border: 1px solid white;
    display: flex;
    justify-content: center;
    align-items: center;
}

.action-txt {
    color: white;
    margin: 0;
}

.myinput {
    width: 200px;
    border: 1px solid white;
    height: 34px;
    border-radius: 10px;
    background: transparent;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
}

.myinput::placeholder {
    padding-left: 4%;
    color: white;
}

.myinput[type=text] {
    color: white;
    padding-left: 4%;
}

.action-soh-txt {
    color: white;
    margin: 0;
    font-size: 11px;
}

.admin-dropdown {
    width: 100%;

}

.link-style-admin-center {
    width: 96%;
    background-color: #56626A;
    height: 40px;
    display: flex;
    padding-left: 2%;
    align-items: center;
    justify-content: center;
    margin-bottom: 1px;
    cursor: pointer;
}

.link-style-admin-center p {
    margin: 0;
}

.link-style-admin-center:hover {
    background-color: #373E43;
}

.main-login {
    width: 100%;
    height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
}

.center-div {
    width: 580px;
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.664);
    border-radius: 8px;
}

.welcome {
    font-size: 35px;
    color: white;
    font-style: bold;
    text-align: center;
}

.user-input {
    width: 380px;
    height: 35px;
    border: 1px solid white;
    margin-bottom: 5%;
}

.user-text-input {
    color: white;

}

.login-btn {
    width: 200px;
    height: 35px;
    background: transparent;
    border: 2px solid white;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10%;
    border-radius: 10px;
    cursor: pointer;
}

.user-login-text {
    margin: 0;
    color: white;
}

.adduser-bottom {
    padding: 2%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

}

.drop-data-new {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 40%;
}


.check-bottom {
    margin-left: 40px;
}

.check {
    display: flex;
}

.check-bottom input[type=checkbox] {
    transform: scale(0.5);
}

.all-para::before {
    content: "•";
}

.all-para {
    font-weight: 600;
    /* color: #000; */
}

.all-checks {
    margin-left: 20px;
}

.flex-role {
    display: flex;
    justify-content: space-between;
    width: 98%;
}

.admin-per {
    padding: 20px;
    border-radius: 10px;
}

.count-per {
    padding: 20px;
    border-radius: 10px;
}

.supply-per {
    padding: 20px;
    border-radius: 10px;
}

.Tagit-per {
    padding: 20px;
    border-radius: 10px;
}

.production-per {
    padding: 20px;
    border-radius: 10px;
}

.rtv-per {
    padding: 20px;
    border-radius: 10px;
}

.modal-div {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.288);
    position: absolute;
    z-index: 111111;
    margin: 0;
    padding: 0;

}

.modal0 {
    width: 500px;

    background-color: transparent;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

}

.qrcode {
    background-color: #eaefef;
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    padding: 5%;
}
.line-line {
    width: 100%; 
    text-align: center; 
    border-bottom: 1px solid #000; 
    line-height: 0.1em;
    margin: 10px 0 20px; 
 } 
 
 .line-line span { 
     background:#fff; 
     padding:0 10px;
 }

.active-tab {
  background-color: #527FA6 !important;
}

.total-score-tag2 {
    font-size: 17px; 
    color: #2c3e50; 
    margin: 0;
    text-transform: capitalize;
    letter-spacing: 0.5px; 
    line-height: 1.4; 
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); 
    font-family: 'Tahoma';
}

.total-score-tag1 {
    font-size: 20px; 
    color: #2c3e50; 
    margin: 0;
    text-transform: capitalize;
    letter-spacing: 0.5px; 
    line-height: 1.4; 
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); 
    font-family: 'Tahoma';
}

.bulkIconsStyle {
    margin-right: 20px;  
    width: 15px;   
    height: 15px;  
}

.bulk-box-1 {
    width: 425px;
    height: 660px;
    background-color: white;   
}

.bulk-box-2 {
    width: 425px;
    height: 660px;
    background-color: white;
    padding-left: 12.75px; 
    padding-right: 12.75px;
}

.form-group {
    display: flex;
    align-items: center;
    margin-bottom: 20px; 
}

.form-group input {
    margin-right: 10px; 
}

.bulkIconsStyle {
    width: 15px; 
    height: 15px;
}

.total-score-tag2 {
    margin: 0;
}

.container {
    padding: 3%;
    margin-top: 10px;
}

.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 15%;
    margin-bottom: 3%;
}

.admin-bottom {
    margin-top: 10px;
}

.bulk-box-1 {
    margin-top: 10px;
}

.label-printing {
    display: flex;
    align-items: center;
}

.bulk-field {
    margin-top: 15px;
    width: 100%; 
}

.bulk-div {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
}

.bulk-row-div{
    padding: 0 3% 0 3%;
}

.bulk-main-div{
    display: flex;
    justify-content: center;
}

.title-style{
    font-size: 25px;
    color: black;
    margin: 0px;
}
.bulk-bottom {
    padding: 1%;
    display: flex;

}

.bulk-container {
    padding: 1rem 0rem;
}

.browse-btn {
    background-color: #0069D9;
    border: none;
    border-radius: 5px;
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    color : white;
    cursor : pointer;
}

.browse-btn:disabled {
    background-color: #575656b8; 
    cursor: not-allowed; 
}

.sub-heading {
    font-size: 20px; 
    color: #fff; 
    margin: 0;
    text-transform: capitalize;
    letter-spacing: 0.5px; 
    line-height: 1.4; 
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); 
    font-family: 'Playfair Display', serif;
}
.view-btn {
    background-color: #259823;
    border: none;
    border-radius: 5px;
    width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    margin-right: 3px;
}
.view-btn:disabled{
    background-color: #575656b8; 
    cursor: not-allowed; 
}
.drill-text {
    font-size: 17px; 
    color: #fff; 
    text-transform: capitalize;
    letter-spacing: 0.5px; 
    line-height: 1.4; 
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); 
    font-family: 'Tahoma';
    margin-top: 10px;
}

.admin-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}
@media (max-width: 480px) {
  .admin-bottom {
    display: none;
  }
  .admin-bottom:first-child {
    display: block; 
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;;;IAGjB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,wDAAwD;AAC5D;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,UAAU;;IAEV,uBAAuB;IACvB,UAAU;;IAEV,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,UAAU;;IAEV,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uBAAuB;;IAEvB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,8BAA8B;;IAE9B,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,UAAU;;IAEV,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;;IAEb,8BAA8B;AAClC;;AAEA;IACI,UAAU;;IAEV,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;;IAEV,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;;AAGtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;;AAE3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;;AAElC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;;AAE3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,YAAY;;AAEhB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;;;;;;;;;;GAWG;;AAEH;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;;IAEnB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,8BAA8B;;AAElC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,8BAA8B;;AAElC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;;IAElB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,8BAA8B;;AAElC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;;;;;;;;;;;GAWG;;AAEH;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,qCAAqC;AACzC;;;;AAIA;;IAEI,aAAa;IACb,sBAAsB;IACtB,wDAAwD;IACxD,gBAAgB;IAChB,uBAAuB,EAAE,sCAAsC;IAC/D,sBAAsB;AAC1B;;;;AAIA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,8BAA8B;;AAElC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,8BAA8B;;;AAGlC;;AAEA;IACI,WAAW;IACX,aAAa;;IAEb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yDAAuD;IACvD,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,8BAA8B;;AAElC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,UAAU;AACd;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,UAAU;;AAEd;;AAEA;IACI,YAAY;;IAEZ,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;;AAEpC;;AAEA;IACI,yBAAyB;IACzB,WAAW;;IAEX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;CACtB;;CAEA;KACI,eAAe;KACf,cAAc;CAClB;;AAED;EACE,oCAAoC;AACtC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,8BAA8B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;;AAEjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;IAC3C,sCAAsC;AAC1C;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,0BAA0B;IAC1B,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;IAC3C,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,uBAAuB;AAC3B;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF","sourcesContent":["body {\n    margin: 0;\n    padding: 0;\n    min-height: 100vh;\n}\n\n.sidebar {\n    /* flex: 1; */\n    min-height: 100vh;\n\n\n    background: black;\n    width: 100%;\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n    z-index: 100;\n    /* box-shadow: 0px 10px 20px rgba(196, 200, 208, 0.4); */\n}\n\n.wid {\n    width: 80px;\n}\n\n.top-side {\n    display: flex;\n    justify-content: center;\n}\n\n.inovent {\n    color: white;\n    font-size: 25px;\n    font-style: bold;\n}\n\n.link-style {\n    width: 96%;\n    background-color: #373E43;\n    height: 40px;\n    display: flex;\n    padding-left: 4%;\n    align-items: center;\n    margin-bottom: 1px;\n    cursor: pointer;\n}\n\n.link-style-center {\n    width: 96%;\n    background-color: #56626A;\n    height: 40px;\n    display: flex;\n    padding-left: 2%;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1px;\n}\n\n.link-style-center:hover {\n    background-color: #373E43;\n    cursor: pointer;\n}\n\n.link-text {\n    color: white;\n    padding-left: 2%;\n    margin: 0;\n}\n\n.header {\n    width: 100%;\n    background-color: black;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.header-text {\n    /* color: white; */\n    padding-left: 2%;\n    margin: 0px;\n    font-size: 13px;\n}\n\n.line {\n    width: 1px;\n    height: 28px;\n    background-color: white;\n    margin-top: 5px;\n    margin-bottom: 3px;\n}\n\n.ino-admin:hover {\n    background-color: #373E43;\n    cursor: pointer;\n}\n\n.dashboard-main {\n    margin: 1%;\n\n    border: 1px solid black;\n    width: 99%;\n\n    display: flex;\n    flex-direction: column;\n\n    border-radius: 15px;\n}\n\n.dashboard-main2 {\n    margin: 1%;\n    margin-right: 0;\n    border: 1px solid black;\n    width: 50%;\n\n    display: flex;\n    flex-direction: column;\n\n    border-radius: 15px;\n}\n\n.dashboard-top {\n    background: #D3D8DB;\n    height: 75px;\n    width: 100%;\n    border-radius: 15px 15px 0 0;\n    padding-top: 1%;\n    padding-left: 2%;\n    padding-right: 2%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.dashboard-top2 {\n    background: #D3D8DB;\n    height: 75px;\n    width: 100%;\n    border-radius: 15px 15px 0 0;\n    padding: 1%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.refresh-btn {\n    background-color: #C82333;\n    border: none;\n    border-radius: 5px;\n    margin-top: 20%;\n    width: 75px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n}\n\n.refresh-text {\n    color: white;\n    margin: 0;\n}\n\n.stock-count {\n    font-size: 22px;\n    margin-top: 0;\n    font-weight: 500;\n    color: #091114;\n}\n\n.dashboard-bottom {\n    padding: 1%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.filter-text {\n    color: white;\n    font-weight: 500;\n}\n\n.drop-input {\n    width: 200px;\n    border: 1px solid white;\n   \n    height: 34px;\n    border-radius: 10px;\n    background: transparent;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.drop-input-black {\n    width: 200px;\n    border: 1px solid rgb(0, 0, 0);\n   \n    height: 34px;\n    border-radius: 10px;\n    color: black !important;\n    background: rgb(240, 240, 240);\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.drop-input-black::placeholder {\n    color: black !important;\n}\n\n.store {\n    color: white;\n    margin: 0;\n    margin-left: 5%;\n}\n\n.dropdown-list {\n    width: 180px;\n    height: 400px;\n    background-color: #373E43;\n    overflow: scroll;\n    scroll-behavior: smooth;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1%;\n    position: absolute;\n}\n\n.drop-data {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.show {\n    /* color: white; */\n    margin: 0 10px 0;\n    font-weight: 500;\n}\n\n.run-btn {\n    background-color: #0069D9;\n    border: none;\n    border-radius: 10px;\n    padding: 10px;\n    min-width: 160px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n}\n\n.run-text {\n    color: white;\n    font-size: 15px;\n    margin: 0;\n}\n\n.box-1 {\n    width: 33%;\n    height: 160px;\n    background-color: #091114;\n    border-radius: 10px;\n    padding: 2%;\n}\n\n.admin-main {\n    margin: 3%;\n    border: 1px solid black;\n    width: 95%;\n\n    display: flex;\n    flex-direction: column;\n\n    border-radius: 15px;\n}\n\n.admin-bottom {\n    padding: 1%;\n    display: flex;\n\n    justify-content: space-between;\n}\n\n.box-2 {\n    width: 66%;\n\n    background-color: #091114;\n    border-radius: 10px;\n    padding: 2%;\n}\n\n.box-3 {\n    width: 33%;\n\n    background-color: #091114;\n    border-radius: 10px;\n    padding: 2%;\n}\n\n.total-score {\n    color: white;\n    font-size: 18px;\n    font-weight: 500;\n    margin: 0;\n}\n\n.circle {\n    border: 2px solid white;\n    width: 30px;\n    border-radius: 50%;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n\n}\n\n.plus {\n    color: white;\n    font-size: 25px;\n    width: 30px;\n    /* height: 45px; */\n    margin: 0;\n    font-weight: 500;\n}\n\n.number {\n    font-size: 100px;\n    color: white;\n    font-weight: bold;\n    margin: 5%;\n    margin-left: 30%;\n    margin-top: -7%\n}\n\n.long-data {\n    color: white;\n    font-size: 13px;\n}\n\n.last {\n    color: white;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.select-store-btn {\n    width: 180px;\n    height: 40px;\n    background: transparent;\n    border: 1px solid white;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.select-store-text {\n    color: white;\n    margin: 0;\n}\n\n.matching {\n    color: white;\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 0;\n}\n\n.zero {\n    font-size: 18px;\n    color: white;\n    font-weight: 500;\n}\n\n.red-line {\n    width: 100%;\n    height: 5px;\n    background-color: #C82333;\n}\n\n.small-text {\n    font-size: 12px;\n    color: white;\n    margin: 0;\n    font-weight: 500;\n}\n\n.small-text-zero {\n    font-size: 12px;\n    color: white;\n    text-align: center;\n    margin: 0;\n    font-weight: 500;\n}\n\n.white-box-1 {\n    width: 335px;\n    height: 420px;\n    background-color: white;\n\n}\n\n.white-box-2 {\n    width: 335px;\n    height: 390px;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n}\n\n.white-box-3 {\n    width: 335px;\n    height: 390px;\n    background-color: white;\n\n}\n\n.total-score-tag {\n    font-size: 15px;\n    font-weight: 500;\n    color: black;\n    margin: 0;\n}\n\n.detail-btn {\n    width: 80px;\n    height: 35px;\n    background-color: rgb(90, 98, 104);\n    border: none;\n    border-radius: 5px;\n}\n\n.detail-text-tag {\n    margin: 0;\n    color: white;\n\n}\n\n.tag-input {\n    width: 185px;\n    height: 30px;\n    border: 1px solid grey;\n    color: #000;\n}\n\n.tag-input::placeholder {\n    color: gray;\n}\n\n.tag-input[type=text] {\n    color: #000\n}\n\n.img-preview {\n    margin: 0;\n    font-weight: 500;\n}\n\n.epc-input {\n    width: 97%;\n    height: 30px;\n    border: 1px solid grey;\n}\n\n.picker-input {\n    width: 200px;\n    border: 1px solid gray;\n    height: 34px;\n    border-radius: 5px;\n    background: transparent;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n/* .picker-list {\n    width: 180px;\n    height: 400px;\n    background-color: transparent;\n    overflow: scroll;\n    scroll-behavior: smooth;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1%;\n} */\n\n.picker-list {\n    /* width: 100%; */\n    height: 237px;\n    position: absolute;\n    /* background-color: #333232; */\n    background: black;\n    scroll-behavior: smooth;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    overflow-y: scroll;\n    /* padding: 1%; */\n    overflow-x: hidden;\n}\n\n.print-btn {\n    background-color: #0069D9;\n    border: none;\n    border-radius: 10px;\n\n    width: 150px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n}\n.print-btn:disabled{\n    cursor: not-allowed; \n}\n\n.print-text {\n    color: white;\n    font-size: 17px;\n    margin: 0;\n}\n\n.users-bottom {\n    padding: 2%;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n\n}\n\n.users-bottom2 {\n    padding: 2%;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n\n}\n\n.role-bottom {\n    padding: 2%;\n    display: flex;\n    width: 90%;\n    /* justify-content: space-between; */\n}\n\n.add-user-btn {\n    background-color: #C82333;\n    border: none;\n    border-radius: 5px;\n    margin-left: 2%;\n    width: 75px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n}\n\n.back-user-btn {\n    background-color: #C82333;\n    border: none;\n    border-radius: 5px;\n\n    width: 75px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    margin-top: 3%;\n    margin-left: 5%;\n    margin-bottom: -3%;\n}\n\n.add-text {\n    color: white;\n    margin: 0;\n    font-size: 13px;\n}\n\n.transfer-bottom {\n    padding: 2%;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n\n}\n\n.forminput {\n    width: 270px;\n    height: 35px;\n    background: transparent;\n    border: 1px solid white;\n    border-radius: 5px;\n}\n\n.forminput:focus {\n    background: white;\n    border: 1px solid white;\n    outline: none;\n}\n\n.forminput::placeholder {\n    padding-left: 10px;\n}\n\n.ibt-text {\n    font-size: 15px;\n    color: white;\n}\n\n.drop-input-form {\n    width: 270px;\n    border: 1px solid white;\n    height: 34px;\n    border-radius: 5px;\n    padding-left: 15px;\n    background: transparent;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.recharts-cartesian-grid-horizontal line {\n    stroke-opacity: 0;\n}\n\n\n/* .dropdown-list-form {\n    width: 280px;\n    height: 400px;\n    background-color: transparent;\n    overflow: scroll;\n    scroll-behavior: smooth;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 1%;\n} */\n\n.dropdown-list-form {\n    width: 100%;\n    height: 237px;\n    position: absolute;\n    /* background-color: #333232; */\n    background: black;\n    scroll-behavior: smooth;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    overflow-y: scroll;\n    padding: 1%;\n    overflow-x: hidden;\n}\n\n.dropdown-para-wrapper:nth-child(even) {\n    background: #212529;\n}\n\n.dropdown-para-wrapper {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.dropdown-para-wrapper p {\n    color: white;\n    font-weight: 400;\n    margin: 0;\n    line-height: 30px;\n    font-size: 12px;\n}\n\n.drop-input-form-2 {\n    width: 100%;\n    border: 1px solid white;\n    height: 34px;\n    border-radius: 5px;\n    background: transparent;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.dropdown-list-form-2 {\n    width: 100%;\n    height: 237px;\n    position: absolute;\n    background: black;\n    scroll-behavior: smooth;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    overflow-y: scroll;\n    padding: 1%;\n    overflow-x: hidden;\n}\n\n.store-2 {\n    color: white;\n    margin: 0;\n    margin-left: 2.1%;\n}\n\n.textarea-form {\n    width: 100%;\n    height: 150px;\n    background: transparent;\n    border: 1px solid white;\n    border-radius: 5px;\n}\n\n.textarea-form:focus {\n    background: white;\n    border: 1px solid white;\n    outline: none;\n}\n\n.textarea-form::placeholder {\n    padding-left: 10px;\n    padding-top: 8px;\n}\n\n.receiving-btn {\n    background-color: #f8f9fa;\n    color: #212529;\n    border: none;\n    border-radius: 5px;\n    width: 200px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    margin-top: 6%;\n}\n\n.get-detail-btn {\n    background-color: #f8f9fa;\n    color: #000;\n    width: 100px;\n    height: 35px;\n    border-radius: 5px;\n}\n\n.clear-btn {\n    background-color: #C82333;\n    border: none;\n    border-radius: 5px;\n    width: 75px;\n    height: 35px;\n    color: white;\n}\n\n.admin-menu-btn {\n    width: 250px;\n    height: 38px;\n    margin-bottom: 2%;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.admin-menu-bottom {\n    padding: 2%;\n}\n\n.admin-menu-txt {\n    color: white;\n    margin: 0;\n}\n\n[data-table-theme*=dark] {\n    width: 100%;\n    color: white;\n    background: #1B1F22;\n    font-size: 10pt;\n    text-align: center;\n    border-collapse: collapse;\n}\n\n[data-table-theme*=#373E43] thead th,\n[data-table-theme*=dark] tfoot th {\n    color: #aaa;\n    background: rgba(0255, 255, 255, .15);\n}\n\n\n\n[data-table-theme*=dark] th,\n[data-table-theme*=dark] td {\n    padding: .5em;\n    border: 1px solid grey;\n    /* Prevent very long content from stretching the table */\n    max-width: 300px;\n    overflow-wrap: anywhere; /* allow breaking long words/strings */\n    word-break: break-word;\n}\n\n\n\n.audit-bottom {\n    padding: 2%;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n\n}\n\n.inventory-bottom {\n    padding: 2%;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n\n\n}\n\n.store-bottom {\n    padding: 2%;\n    display: flex;\n\n    justify-content: space-between;\n}\n\n.action-btn {\n    width: 60px;\n    height: 30px;\n    background: transparent;\n    border: 1px solid white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.action-txt {\n    color: white;\n    margin: 0;\n}\n\n.myinput {\n    width: 200px;\n    border: 1px solid white;\n    height: 34px;\n    border-radius: 10px;\n    background: transparent;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.myinput::placeholder {\n    padding-left: 4%;\n    color: white;\n}\n\n.myinput[type=text] {\n    color: white;\n    padding-left: 4%;\n}\n\n.action-soh-txt {\n    color: white;\n    margin: 0;\n    font-size: 11px;\n}\n\n.admin-dropdown {\n    width: 100%;\n\n}\n\n.link-style-admin-center {\n    width: 96%;\n    background-color: #56626A;\n    height: 40px;\n    display: flex;\n    padding-left: 2%;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1px;\n    cursor: pointer;\n}\n\n.link-style-admin-center p {\n    margin: 0;\n}\n\n.link-style-admin-center:hover {\n    background-color: #373E43;\n}\n\n.main-login {\n    width: 100%;\n    height: 100vh;\n    background-image: url(/src/assets/nesto-background.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.center-div {\n    width: 580px;\n    height: 400px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.664);\n    border-radius: 8px;\n}\n\n.welcome {\n    font-size: 35px;\n    color: white;\n    font-style: bold;\n    text-align: center;\n}\n\n.user-input {\n    width: 380px;\n    height: 35px;\n    border: 1px solid white;\n    margin-bottom: 5%;\n}\n\n.user-text-input {\n    color: white;\n\n}\n\n.login-btn {\n    width: 200px;\n    height: 35px;\n    background: transparent;\n    border: 2px solid white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 10%;\n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.user-login-text {\n    margin: 0;\n    color: white;\n}\n\n.adduser-bottom {\n    padding: 2%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n}\n\n.drop-data-new {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    width: 40%;\n}\n\n\n.check-bottom {\n    margin-left: 40px;\n}\n\n.check {\n    display: flex;\n}\n\n.check-bottom input[type=checkbox] {\n    transform: scale(0.5);\n}\n\n.all-para::before {\n    content: \"•\";\n}\n\n.all-para {\n    font-weight: 600;\n    /* color: #000; */\n}\n\n.all-checks {\n    margin-left: 20px;\n}\n\n.flex-role {\n    display: flex;\n    justify-content: space-between;\n    width: 98%;\n}\n\n.admin-per {\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.count-per {\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.supply-per {\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.Tagit-per {\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.production-per {\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.rtv-per {\n    padding: 20px;\n    border-radius: 10px;\n}\n\n.modal-div {\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.288);\n    position: absolute;\n    z-index: 111111;\n    margin: 0;\n    padding: 0;\n\n}\n\n.modal0 {\n    width: 500px;\n\n    background-color: transparent;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n.qrcode {\n    background-color: #eaefef;\n    width: 100%;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 15px;\n    padding: 5%;\n}\n.line-line {\n    width: 100%; \n    text-align: center; \n    border-bottom: 1px solid #000; \n    line-height: 0.1em;\n    margin: 10px 0 20px; \n } \n \n .line-line span { \n     background:#fff; \n     padding:0 10px;\n }\n\n.active-tab {\n  background-color: #527FA6 !important;\n}\n\n.total-score-tag2 {\n    font-size: 17px; \n    color: #2c3e50; \n    margin: 0;\n    text-transform: capitalize;\n    letter-spacing: 0.5px; \n    line-height: 1.4; \n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); \n    font-family: 'Tahoma';\n}\n\n.total-score-tag1 {\n    font-size: 20px; \n    color: #2c3e50; \n    margin: 0;\n    text-transform: capitalize;\n    letter-spacing: 0.5px; \n    line-height: 1.4; \n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); \n    font-family: 'Tahoma';\n}\n\n.bulkIconsStyle {\n    margin-right: 20px;  \n    width: 15px;   \n    height: 15px;  \n}\n\n.bulk-box-1 {\n    width: 425px;\n    height: 660px;\n    background-color: white;   \n}\n\n.bulk-box-2 {\n    width: 425px;\n    height: 660px;\n    background-color: white;\n    padding-left: 12.75px; \n    padding-right: 12.75px;\n}\n\n.form-group {\n    display: flex;\n    align-items: center;\n    margin-bottom: 20px; \n}\n\n.form-group input {\n    margin-right: 10px; \n}\n\n.bulkIconsStyle {\n    width: 15px; \n    height: 15px;\n}\n\n.total-score-tag2 {\n    margin: 0;\n}\n\n.container {\n    padding: 3%;\n    margin-top: 10px;\n}\n\n.button-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-top: 15%;\n    margin-bottom: 3%;\n}\n\n.admin-bottom {\n    margin-top: 10px;\n}\n\n.bulk-box-1 {\n    margin-top: 10px;\n}\n\n.label-printing {\n    display: flex;\n    align-items: center;\n}\n\n.bulk-field {\n    margin-top: 15px;\n    width: 100%; \n}\n\n.bulk-div {\n   display: flex;\n   flex-direction: row;\n   justify-content: space-between;\n}\n\n.bulk-row-div{\n    padding: 0 3% 0 3%;\n}\n\n.bulk-main-div{\n    display: flex;\n    justify-content: center;\n}\n\n.title-style{\n    font-size: 25px;\n    color: black;\n    margin: 0px;\n}\n.bulk-bottom {\n    padding: 1%;\n    display: flex;\n\n}\n\n.bulk-container {\n    padding: 1rem 0rem;\n}\n\n.browse-btn {\n    background-color: #0069D9;\n    border: none;\n    border-radius: 5px;\n    width: 70px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    color : white;\n    cursor : pointer;\n}\n\n.browse-btn:disabled {\n    background-color: #575656b8; \n    cursor: not-allowed; \n}\n\n.sub-heading {\n    font-size: 20px; \n    color: #fff; \n    margin: 0;\n    text-transform: capitalize;\n    letter-spacing: 0.5px; \n    line-height: 1.4; \n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); \n    font-family: 'Playfair Display', serif;\n}\n.view-btn {\n    background-color: #259823;\n    border: none;\n    border-radius: 5px;\n    width: 45px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    margin-right: 3px;\n}\n.view-btn:disabled{\n    background-color: #575656b8; \n    cursor: not-allowed; \n}\n.drill-text {\n    font-size: 17px; \n    color: #fff; \n    text-transform: capitalize;\n    letter-spacing: 0.5px; \n    line-height: 1.4; \n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1); \n    font-family: 'Tahoma';\n    margin-top: 10px;\n}\n\n.admin-content {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    justify-content: center;\n}\n@media (max-width: 480px) {\n  .admin-bottom {\n    display: none;\n  }\n  .admin-bottom:first-child {\n    display: block; \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
